var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"primary"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.devices),function(item,index){return _c('v-col',{key:index,attrs:{"cols":9}},[_c(item,{tag:"component",attrs:{"is-modal":false}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }